import React from 'react'
// MUI
import {styled} from '@material-ui/core/styles'
import { NavLink } from "react-router-dom";
import Button from "@material-ui/core/Button";
import './Navbar.css'
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

const NavLinksStyle=styled(NavLink)({
    color:'#fff',
    padding:'0px 10px',
    width:'max-content',
    display:'flex',
    height:'60px',
    textDecoration:'none',
    '&:hover':{
      textDecoration:'none',
        border:'none'
    }
  })

const NavButtonStyle=styled(Button)({
  color:'#ffffff',
    border:'none',
    '&:hover':{
        textDecoration:'none',
        border:'none',
        outline:'none'
    },
    '&:focus':{
        textDecoration:'none',
        border:'none',
        outline:'none'
    },
  })


const NavListDisplay = ({authenticated,data}) => {

    return (
        <>
        <NavLinksStyle
            exact
            to={"/"}
            activeClassName="navbarctive"
        >
            <NavButtonStyle>Home</NavButtonStyle>
          </NavLinksStyle>

          {authenticated &&
          <NavLinksStyle
              to="/requestservice"
              activeClassName="navbarctive"
          >
            <NavButtonStyle style={{border:0}}>Request Service</NavButtonStyle>

          </NavLinksStyle>}

          {!authenticated &&
          <NavLinksStyle
              to="/register"
              activeClassName="navbarctive"
          >
            <NavButtonStyle>Register</NavButtonStyle>
          </NavLinksStyle>}

          {authenticated &&
          <NavLinksStyle
              to="/account"
              activeClassName="navbarctive"
          >
            <NavButtonStyle>Account</NavButtonStyle>
          </NavLinksStyle>}
        {authenticated && data.professional &&
          <NavLinksStyle
              to="/requests"
              activeClassName="navbarctive"
          >
           <NavButtonStyle>Requests</NavButtonStyle>
          </NavLinksStyle>}
            <a href={"https://blog.aturservices.co.in"}>


                <NavButtonStyle>Blog</NavButtonStyle>
            </a>
          <NavLinksStyle
            to="/pricing"
            activeClassName="navbarctive"
        >
            <NavButtonStyle>Pricing</NavButtonStyle>
        </NavLinksStyle>

          <NavLinksStyle
            to={"/aboutus"}
            id="icontoggler"
            activeClassName="navbarctive"
          >
           <NavButtonStyle style={{width:'100px'}}>About Us</NavButtonStyle>
          </NavLinksStyle>
        </>
    )
}

export default NavListDisplay
